import { gql } from '@apollo/client';

export const ADD_INFLUENCER_CATEGORY = gql`
  mutation AddInfluencerCategory($input: AddInfluencerCategoryInput!) {
    addInfluencerCategory(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_INFLUENCER_CATEGORY = gql`
  mutation UpdateInfluencerCategory($input: UpdateInfluencerCategoryInput!) {
    updateInfluencerCategory(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_INFLUENCER_CATEGORY = gql`
  mutation DeleteInfluencerCategory($id: Int!) {
    deleteInfluencerCategory(id: $id) {
      id
      name
    }
  }
`;
